import React, { Component } from "react";
import { connect } from "react-redux";

import { CDialog, P } from "@appcues/component-library";
import { deleteSegmentAndFlushSegment } from "actions/segments";
import { selectConditionsBySegmentId } from "reducers/account/conditions";
import { selectAccountChecklists } from "reducers/account/checklists";
import { getMatchingSegments, getMatchingChecklists } from "utils/segments";
import { selectAccountSegments } from "reducers/account/segments";

import { navigate } from "actions/routing";
import { hideModal } from "actions/currentModal";
import { callApi as fetchRules } from "actions/account/rules";
import { setFlowSegmentFilter } from "actions/view";
import "components/ModalContainer/DeleteSegmentModal/style.scss";

export class DeleteSegmentModal extends Component {
  componentDidMount() {
    this.props.onLoad();
  }

  handleSegmentDeletion = () => {
    const { segmentId, deleteSegmentAndFlushSegment, hideModal } = this.props;

    deleteSegmentAndFlushSegment(segmentId);
    hideModal();
  };

  navigateToFlowsPage = () => {
    const { segmentId, hideModal, navigate, setFlowSegmentFilter } = this.props;

    hideModal();
    navigate("/flows");
    setFlowSegmentFilter(segmentId);
  };

  render() {
    const {
      segmentId,
      matchingFlows,
      segments,
      checklists,
      hideModal
    } = this.props;

    const numberOfMatchingFlows = matchingFlows.length;
    const numberOfMatchingSegments = getMatchingSegments(segmentId, segments)
      .length;
    const numberOfMatchingChecklists = getMatchingChecklists(
      segmentId,
      checklists
    ).length;

    const pluralize = targetingCondition => {
      let matchingCount;
      if (targetingCondition === "flow") {
        matchingCount = numberOfMatchingFlows;
      } else if (targetingCondition === "checklist") {
        matchingCount = numberOfMatchingChecklists;
      } else {
        matchingCount = numberOfMatchingSegments;
      }
      return matchingCount === 1
        ? `${matchingCount} ${targetingCondition}`
        : `${matchingCount} ${targetingCondition}s`;
    };

    const targetingConditionsText =
      numberOfMatchingFlows > 0 && numberOfMatchingSegments > 0
        ? `${pluralize("flow")} and ${pluralize("segment")}`
        : numberOfMatchingFlows > 0
        ? `${pluralize("flow")}`
        : numberOfMatchingSegments > 0
        ? `${pluralize("segment")}`
        : `${pluralize("checklist")}`;

    if (
      numberOfMatchingFlows ||
      numberOfMatchingSegments ||
      numberOfMatchingChecklists
    ) {
      return (
        <CDialog
          title="This segment can't be deleted"
          primaryActionText="Okay"
          secondaryActionText={
            numberOfMatchingFlows > 0 ? "View flows using this segment" : null
          }
          onPrimaryAction={hideModal}
          onSecondaryAction={
            numberOfMatchingFlows > 0 ? this.navigateToFlowsPage : null
          }
        >
          <P>
            Segments can't be deleted when they are used in the targeting
            conditions for other segments, flows, or checklists.
          </P>
          <P>
            To delete this segment, it must be removed from the targeting
            conditions of <strong>{targetingConditionsText}</strong>.
          </P>
        </CDialog>
      );
    }
    return (
      <CDialog
        title="Delete this segment?"
        type="negative"
        primaryActionText="Delete"
        onPrimaryAction={this.handleSegmentDeletion}
        secondaryActionText="Cancel"
        onSecondaryAction={hideModal}
      >
        <P>
          Are you sure you want to delete this segment?
          <br />
          This cannot be undone.
        </P>
      </CDialog>
    );
  }
}

function mapStateToProps(state, { segmentId }) {
  return {
    matchingFlows: selectConditionsBySegmentId(state, { segmentId }),
    segments: selectAccountSegments(state),
    checklists: selectAccountChecklists(state)
  };
}

const mapDispatchToProps = {
  onLoad: fetchRules,
  deleteSegmentAndFlushSegment,
  navigate,
  hideModal,
  setFlowSegmentFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSegmentModal);
